import { css } from 'lit-element';
const style = css`
fc-date-picker {
  --fc-date-picker-font-size: 12px;
}`;
export default style;
